module.exports = __webpack_public_path__ + "static/media/photo23.595ad732.svg";